import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import './DisclaimerMark.scss';
import DisclaimerMark from './DisclaimerMark';

const mapStateToProps = (state, ownProps) => {

  return {
    ...ownProps
  };
};

const mapDispatchToProps = (_) => {
  return {
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const DisclaimerMarkContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(DisclaimerMark);

export { DisclaimerMarkContainer, DisclaimerMark };

DisclaimerMarkContainer.propTypes = {
  title: PropTypes.string,
};

export default DisclaimerMarkContainer;